import React from 'react';
import WidgetCard from './WidgetCard';
import { Box } from '@mui/material';

export default function GroupContainer({ group }) {
  return (
    <section>
      <h2>{group.group_desc}</h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          // justifyContent: 'center',
          gap: 2,
        }}
      >
        {group.widgets.map((widget) => (
          <WidgetCard key={widget.pk_id} widget={widget} isGroupWithFilter = {group.pk_id !== 4} />
        ))}
      </div>
    </section>
  );
}
